import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Column chart type
 * Extends the base chart configuration
 */
export const columnChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'column'
    },
    plotOptions: {
        column: {
            borderRadius: 2,
            borderWidth: 0,
            pointPadding: 0.1,
            groupPadding: 0.2,
            states: {
                hover: {
                    brightness: 0.1
                }
            }
        }
    },
    tooltip: {
        headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
        pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
    }
} as Options);